import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio'; 
import Contact from './components/Contact';
import ClientSay from './components/Clientsay';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <Header />
      <Home />
      <About />
      <Services />
      <Portfolio />
      <ClientSay />
      <Contact />
      <Footer/>
    </>
  );
}

export default App;
